import React from "react";
import '../../pages/pages.css'

const Input = ({ type, placeholder, value, onChange }) => {
  return (
      <input 
        className="input_email_senha"
        value={value}
        onChange={onChange}
        type={type}
        placeholder={placeholder}
      >
      </input>
  );
};

export default Input;